import React from "react";
import NewAds from "../../assets/data/NewAds.js";

function NewAdd() {
  const totalAds = NewAds.length;
  return (
    <div className="MainDashboard flex items-center justify-between">
      <div className="Table lg:w-[420px] md:w-[420px] w-[360px]  rounded-lg p-4 bg-white">
        <div className="flex items-center justify-between mb-2">
          <h2 className="text-lg font-semibold mb-2">New Ads</h2>
          <div className="relative">
            <i
              className="fa fa-bell text-[24px] relative"
              aria-hidden="true"
            ></i>
            {totalAds > 0 && (
              <span className="absolute top-[-5px] right-[-5px] bg-red-600 text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center">
                {totalAds}
              </span>
            )}
          </div>
        </div>

        {/* Table Container with Scroll */}
        <div className="overflow-y-auto" style={{ height: "250px" }}>
          <table className="w-full border-collapse text-sm">
            {/* Sticky Table Header */}
            <thead className="sticky top-0 bg-gray-200">
              <tr className="text-gray-700">
                <th className="p-2 border-b">Client</th>
                <th className="p-2 border-b ">Phone</th>
                <th className="p-2 border-b ">Address</th>
                <th className="p-2 border-b">Category</th>
                <th className="p-2 border-b">Image</th>
              </tr>
            </thead>
            <tbody>
              {NewAds.map((Ad) => (
                <tr className="hover:bg-gray-100" key={Ad._id}>
                  <td className="p-2 border-b text-center">{Ad.client}</td>
                  <td className="p-2 border-b text-center">{Ad.phone}</td>
                  <td className="p-2 border-b text-center">{Ad.address}</td>
                  <td className="p-2 border-b text-center">{Ad.category}</td>
                  <td className="p-2 border-b text-center">
                    <img src={Ad.image} alt="AdPhoto" className="w-8 h-8" />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default NewAdd;
